// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StartAiDispositiveProvisionWorkflowMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.StartAiDispositiveProvisionWorkflowInput>;
}>;


export type StartAiDispositiveProvisionWorkflowMutation = { __typename?: 'Mutation', startAIDispositiveProvisionWorkflow?: { __typename?: 'AsyncJob', id: string } | null };

export type StartAiDispositiveProvisionWorkflowForEntitiesMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.StartAiDispositiveProvisionWorkflowInputForEntitiesInput>;
}>;


export type StartAiDispositiveProvisionWorkflowForEntitiesMutation = { __typename?: 'Mutation', startAIDispositiveProvisionWorkflowForEntities: Array<{ __typename?: 'AsyncJob', id: string }> };

export type StartAiDispositiveProvisionWorkflowForTeMutationVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.StartAiDispositiveProvisionWorkflowForTeInput>;
}>;


export type StartAiDispositiveProvisionWorkflowForTeMutation = { __typename?: 'Mutation', startAIDispositiveProvisionWorkflowForTE: { __typename?: 'AsyncJob', id: string } };

export const Operations = {
  Mutation: {
    StartAIDispositiveProvisionWorkflow: 'StartAIDispositiveProvisionWorkflow' as const,
    StartAIDispositiveProvisionWorkflowForEntities: 'StartAIDispositiveProvisionWorkflowForEntities' as const,
    StartAIDispositiveProvisionWorkflowForTE: 'StartAIDispositiveProvisionWorkflowForTE' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}


export const StartAiDispositiveProvisionWorkflowDocument = gql`
    mutation StartAIDispositiveProvisionWorkflow($input: StartAIDispositiveProvisionWorkflowInput) {
  startAIDispositiveProvisionWorkflow(input: $input) {
    id
  }
}
    `;
export type StartAiDispositiveProvisionWorkflowMutationFn = Apollo.MutationFunction<StartAiDispositiveProvisionWorkflowMutation, StartAiDispositiveProvisionWorkflowMutationVariables>;

/**
 * __useStartAiDispositiveProvisionWorkflowMutation__
 *
 * To run a mutation, you first call `useStartAiDispositiveProvisionWorkflowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiDispositiveProvisionWorkflowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiDispositiveProvisionWorkflowMutation, { data, loading, error }] = useStartAiDispositiveProvisionWorkflowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiDispositiveProvisionWorkflowMutation(baseOptions?: Apollo.MutationHookOptions<StartAiDispositiveProvisionWorkflowMutation, StartAiDispositiveProvisionWorkflowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiDispositiveProvisionWorkflowMutation, StartAiDispositiveProvisionWorkflowMutationVariables>(StartAiDispositiveProvisionWorkflowDocument, options);
      }
export type StartAiDispositiveProvisionWorkflowMutationHookResult = ReturnType<typeof useStartAiDispositiveProvisionWorkflowMutation>;
export type StartAiDispositiveProvisionWorkflowMutationResult = Apollo.MutationResult<StartAiDispositiveProvisionWorkflowMutation>;
export type StartAiDispositiveProvisionWorkflowMutationOptions = Apollo.BaseMutationOptions<StartAiDispositiveProvisionWorkflowMutation, StartAiDispositiveProvisionWorkflowMutationVariables>;
export const StartAiDispositiveProvisionWorkflowForEntitiesDocument = gql`
    mutation StartAIDispositiveProvisionWorkflowForEntities($input: StartAIDispositiveProvisionWorkflowInputForEntitiesInput) {
  startAIDispositiveProvisionWorkflowForEntities(input: $input) {
    id
  }
}
    `;
export type StartAiDispositiveProvisionWorkflowForEntitiesMutationFn = Apollo.MutationFunction<StartAiDispositiveProvisionWorkflowForEntitiesMutation, StartAiDispositiveProvisionWorkflowForEntitiesMutationVariables>;

/**
 * __useStartAiDispositiveProvisionWorkflowForEntitiesMutation__
 *
 * To run a mutation, you first call `useStartAiDispositiveProvisionWorkflowForEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiDispositiveProvisionWorkflowForEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiDispositiveProvisionWorkflowForEntitiesMutation, { data, loading, error }] = useStartAiDispositiveProvisionWorkflowForEntitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiDispositiveProvisionWorkflowForEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<StartAiDispositiveProvisionWorkflowForEntitiesMutation, StartAiDispositiveProvisionWorkflowForEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiDispositiveProvisionWorkflowForEntitiesMutation, StartAiDispositiveProvisionWorkflowForEntitiesMutationVariables>(StartAiDispositiveProvisionWorkflowForEntitiesDocument, options);
      }
export type StartAiDispositiveProvisionWorkflowForEntitiesMutationHookResult = ReturnType<typeof useStartAiDispositiveProvisionWorkflowForEntitiesMutation>;
export type StartAiDispositiveProvisionWorkflowForEntitiesMutationResult = Apollo.MutationResult<StartAiDispositiveProvisionWorkflowForEntitiesMutation>;
export type StartAiDispositiveProvisionWorkflowForEntitiesMutationOptions = Apollo.BaseMutationOptions<StartAiDispositiveProvisionWorkflowForEntitiesMutation, StartAiDispositiveProvisionWorkflowForEntitiesMutationVariables>;
export const StartAiDispositiveProvisionWorkflowForTeDocument = gql`
    mutation StartAIDispositiveProvisionWorkflowForTE($input: StartAIDispositiveProvisionWorkflowForTEInput) {
  startAIDispositiveProvisionWorkflowForTE(input: $input) {
    id
  }
}
    `;
export type StartAiDispositiveProvisionWorkflowForTeMutationFn = Apollo.MutationFunction<StartAiDispositiveProvisionWorkflowForTeMutation, StartAiDispositiveProvisionWorkflowForTeMutationVariables>;

/**
 * __useStartAiDispositiveProvisionWorkflowForTeMutation__
 *
 * To run a mutation, you first call `useStartAiDispositiveProvisionWorkflowForTeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAiDispositiveProvisionWorkflowForTeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAiDispositiveProvisionWorkflowForTeMutation, { data, loading, error }] = useStartAiDispositiveProvisionWorkflowForTeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAiDispositiveProvisionWorkflowForTeMutation(baseOptions?: Apollo.MutationHookOptions<StartAiDispositiveProvisionWorkflowForTeMutation, StartAiDispositiveProvisionWorkflowForTeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAiDispositiveProvisionWorkflowForTeMutation, StartAiDispositiveProvisionWorkflowForTeMutationVariables>(StartAiDispositiveProvisionWorkflowForTeDocument, options);
      }
export type StartAiDispositiveProvisionWorkflowForTeMutationHookResult = ReturnType<typeof useStartAiDispositiveProvisionWorkflowForTeMutation>;
export type StartAiDispositiveProvisionWorkflowForTeMutationResult = Apollo.MutationResult<StartAiDispositiveProvisionWorkflowForTeMutation>;
export type StartAiDispositiveProvisionWorkflowForTeMutationOptions = Apollo.BaseMutationOptions<StartAiDispositiveProvisionWorkflowForTeMutation, StartAiDispositiveProvisionWorkflowForTeMutationVariables>;